import { render, staticRenderFns } from "./PayslipList.vue?vue&type=template&id=b88d05a0&scoped=true"
import script from "./PayslipList.vue?vue&type=script&lang=js"
export * from "./PayslipList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88d05a0",
  null
  
)

export default component.exports